import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    row-gap: var(--spacing-3);
    flex-wrap: wrap;

    @media screen and (min-width: ${breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        column-gap: var(--spacing-4);
        row-gap: var(--spacing-4);
    }
`;

export const Card = css`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-4);
    padding: var(--spacing-3);
    background-color: var(--color-white);

    @media screen and (min-width: ${breakpoints.md}) {
        row-gap: var(--spacing-2);
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    margin-top: auto;
`;

export const Info = styled.div`
    ${Card};
    order: 1;
`;

export const ApprovedStyles = styled.div`
    ${Card};
    order: 2;

    @media screen and (min-width: ${breakpoints.md}) {
        order: 3;
    }
`;

export const Map = styled.div<{ hasOpeninghours?: boolean }>`
    position: relative;
    order: 3;
    height: 470px;
    border: 1px solid var(--color-titanium);
    border-radius: 4px;

    ${({ hasOpeninghours }) =>
        hasOpeninghours &&
        css`
            grid-row: span 2;
        `};

    & > div {
        height: 100%;
        min-height: 470px;
        background-color: var(--color-white);
        border-radius: 4px;
        overflow: hidden;
    }

    a {
        position: absolute;
        top: 100%;
        left: 24px;
        width: calc(100% - 48px);
        transform: translateY(calc(-100% - 24px));
        z-index: 1000;
    }

    @media screen and (min-width: ${breakpoints.md}) {
        order: 2;
        height: auto;
    }
`;
